import { render, staticRenderFns } from "./QuestInsurance.vue?vue&type=template&id=01218373&scoped=true&"
import script from "./QuestInsurance.ts?vue&type=script&lang=ts&"
export * from "./QuestInsurance.ts?vue&type=script&lang=ts&"
import style0 from "./QuestInsurance.scss?vue&type=style&index=0&id=01218373&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01218373",
  null
  
)

export default component.exports